const enc = encodeURIComponent;
const qs = (params) => {
    const parts = Object.entries(params).filter(([, v]) => v !== undefined && v !== '').map(([k, v]) => `${k}=${enc(String(v))}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
};
const driverPath = (driverId, line) => `/v1/admin/provider-services/drivers/${enc(driverId)}/${enc(line)}`;
/** The operator's review of the provider service lines (`driver:view` / `driver:approve` / `driver:suspend`, GEO at the driver's market). */
export class ProviderServicesAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    queue(query) {
        const states = query.states !== undefined && query.states.length > 0 ? query.states.join(',') : undefined;
        return this.client.request({ method: 'GET', path: `/v1/admin/provider-services/queue${qs({ marketId: query.marketId, line: query.line, state: states, limit: query.limit })}`, auth: true });
    }
    provider(driverId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/provider-services/drivers/${enc(driverId)}`, auth: true });
    }
    review(driverId, line, input) {
        return this.client.request({ method: 'POST', path: `${driverPath(driverId, line)}/review`, body: input, auth: true });
    }
    suspendLine(driverId, line, input) {
        return this.client.request({ method: 'POST', path: `${driverPath(driverId, line)}/suspension`, body: input, auth: true });
    }
    suspendVehicle(driverId, line, vehicleId, input) {
        return this.client.request({ method: 'POST', path: `${driverPath(driverId, line)}/vehicles/${enc(vehicleId)}/suspension`, body: input, auth: true });
    }
    approveVehicle(driverId, line, vehicleId, input = {}) {
        return this.client.request({ method: 'POST', path: `${driverPath(driverId, line)}/vehicles/${enc(vehicleId)}/approval`, body: input, auth: true });
    }
}
//# sourceMappingURL=admin-provider-services.js.map